import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks.
 * Only allows safe HTML tags and attributes.
 */
export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return '';
  
  // Clean up escaped newlines that might be stored as literal \n strings
  let cleanedHtml = html
    .replace(/\\n/g, '')  // Remove literal \n (they're not needed in HTML)
    .replace(/\\"/g, '"'); // Unescape quotes
  
  // Convert markdown-style links [text](url) to HTML <a> tags
  cleanedHtml = cleanedHtml.replace(
    /\[([^\]]+)\]\(([^)]+)\)/g,
    '<a href="$2">$1</a>'
  );
  
  return DOMPurify.sanitize(cleanedHtml, {
    ALLOWED_TAGS: [
      'p', 'br', 'b', 'i', 'em', 'strong', 'u', 's',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li',
      'a', 'span', 'div',
      'blockquote', 'pre', 'code',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
    ],
    ALLOWED_ATTR: [
      'href', 'target', 'rel', 'class', 'id', 'style',
    ],
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target'],
    FORBID_TAGS: ['script', 'style', 'iframe', 'form', 'input', 'button', 'object', 'embed'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
  });
}
